import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subject, filter, map, startWith, takeUntil } from 'rxjs';
import { DriverSimulationSelectorComponent } from 'app/layout/common/driver-simulation-selector/driver-simulation-selector.component';
import { DriverTabBarComponent, DriverTabId } from '../../components/driver-tab-bar/driver-tab-bar.component';
import { DriverContextService } from '../../services/driver-context.service';
import { DriverSocketService } from '../../services/driver-socket.service';

const TAB_ROUTES: Record<string, DriverTabId> = {
    '/driver/home': 'home',
    '/driver/map': 'map',
    '/driver/profile': 'profile',
};

const TAB_BAR_PATHS = Object.keys(TAB_ROUTES);
const TRIP_ROUTE_PREFIX = '/driver/service/route/';

@Component({
    selector: 'driver-layout',
    standalone: true,
    imports: [CommonModule, RouterOutlet, DriverTabBarComponent, DriverSimulationSelectorComponent],
    templateUrl: './driver-layout.component.html',
    styleUrls: ['./driver-layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DriverLayoutComponent implements OnInit, OnDestroy {
    showTabBar = false;
    activeTab: DriverTabId = 'home';
    contentFlush = false;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly router: Router,
        private readonly driverContext: DriverContextService,
        private readonly driverSocket: DriverSocketService,
        @Inject(DOCUMENT) private readonly document: Document,
    ) {}

    ngOnInit(): void {
        this.document.documentElement.classList.add('driver-app-active');
        this.document.body.classList.add('driver-app-active');
        this.driverContext.refresh();
        this.driverSocket.start();

        this.router.events
            .pipe(
                filter((e): e is NavigationEnd => e instanceof NavigationEnd),
                map(() => this.router.url.split('?')[0]),
                startWith(this.router.url.split('?')[0]),
                takeUntil(this.destroy$),
            )
            .subscribe((url) => {
                this.showTabBar = TAB_BAR_PATHS.includes(url) || url.startsWith(TRIP_ROUTE_PREFIX);
                this.activeTab = TAB_ROUTES[url] ?? 'home';
                this.contentFlush = url === '/driver/map' || url === '/driver/service/navigation';
            });
    }

    ngOnDestroy(): void {
        this.document.documentElement.classList.remove('driver-app-active');
        this.document.body.classList.remove('driver-app-active');
        this.destroy$.next();
        this.destroy$.complete();
    }
}
